import React from "react";

import { MTableCell } from "material-table";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  // Cell editing wraps the value in a max-content div, which ignores the
  // cell's text alignment; push it right for numeric columns.
  rightAligned: {
    "& > div": {
      marginLeft: "auto",
    },
  },
});

// material-table Cell for tables using cellEditable. Keeps numeric and
// currency values right-aligned, and lets a column opt out of click-to-edit
// with `disableCellEdit: true` while staying editable when adding a row.
const EditableTableCell = (props) => {
  const classes = useStyles();
  const { columnDef } = props;

  return (
    <MTableCell
      {...props}
      cellEditable={columnDef.disableCellEdit ? false : props.cellEditable}
      className={
        ["currency", "numeric"].includes(columnDef.type)
          ? classes.rightAligned
          : undefined
      }
    />
  );
};

export default EditableTableCell;
